import { z } from 'zod'

export const MAX_TRADING_TOKEN_MINUTES = 240

export const tradingTokenModeSchema = z.enum(['none', 'ephemeral', 'persistent'])
export type TradingTokenMode = z.infer<typeof tradingTokenModeSchema>

// setting/arming a per-account full token: persistent (stored at rest) or ephemeral (armed N min)
export const setTradingTokenSchema = z
  .object({
    token: z.string().min(10).max(200),
    mode: z.enum(['persistent', 'ephemeral']),
    durationMinutes: z.number().int().min(1).max(MAX_TRADING_TOKEN_MINUTES).optional(),
  })
  .refine((d) => d.mode === 'persistent' || d.durationMinutes !== undefined, {
    message: 'durationMinutes is required for ephemeral mode',
    path: ['durationMinutes'],
  })
  .refine((d) => d.mode === 'ephemeral' || d.durationMinutes === undefined, {
    message: 'durationMinutes is not allowed for persistent mode',
    path: ['durationMinutes'],
  })
export type SetTradingTokenDto = z.infer<typeof setTradingTokenSchema>

export const extendTradingTokenSchema = z.object({
  durationMinutes: z.number().int().min(1).max(MAX_TRADING_TOKEN_MINUTES),
})
export type ExtendTradingTokenDto = z.infer<typeof extendTradingTokenSchema>

export const tradingTokenStatusSchema = z.object({
  mode: tradingTokenModeSchema,
  expiresAt: z.coerce.date().nullable(),
  remainingSeconds: z.number().int().nonnegative(),
})
export type TradingTokenStatusDto = z.infer<typeof tradingTokenStatusSchema>
